import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from './OnboardingProvider';

// Contextual inline banner rendered above search results.
// Shows the highest-priority contextual nudge for the user's current progress.
export default function ProgressiveNudge() {
  const navigate = useNavigate();
  const { nudgeType, dismissNudge } = useOnboarding();

  if (!nudgeType) return null;

  const configs = {
    firstTune: {
      text: 'Ready to get started? Tap + to add your first tune.',
      action: { label: '+ Add Tune', onClick: () => navigate('/add') },
      dismissible: false,
      color: '#228be6',
    },
    makeSet: {
      text: 'You\'ve got a few tunes — try grouping them into a set for gigs or practice!',
      action: null,
      dismissible: true,
      dismissKey: 'makeSet',
      color: '#7c3aed',
    },
    startSession: {
      text: 'You have a set! Track your playing history with Sessions.',
      action: { label: 'Try Sessions', onClick: () => navigate('/sessions') },
      dismissible: true,
      dismissKey: 'startSession',
      color: '#0891b2',
    },
    settings: {
      text: 'You\'re building a solid collection! Visit Settings to customise themes, genres, and more.',
      action: { label: 'Open Settings', onClick: () => navigate('/settings') },
      dismissible: true,
      dismissKey: 'settings',
      color: '#d97706',
    },
    social: {
      text: 'Share your repertoire — explore Social to follow musicians and exchange tunes.',
      action: { label: 'Explore Social', onClick: () => navigate('/social') },
      dismissible: true,
      dismissKey: 'social',
      color: '#059669',
    },
  };

  const cfg = configs[nudgeType];
  if (!cfg) return null;

  return (
    <div style={{
      margin: '0 0 12px 0',
      padding: '11px 14px',
      borderRadius: '12px',
      background: `color-mix(in srgb, ${cfg.color} 8%, var(--bg-card, #fff) 92%)`,
      border: `1px solid color-mix(in srgb, ${cfg.color} 30%, var(--border-color, #ccc) 70%)`,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: '10px',
      textAlign: 'center',
      fontSize: '0.88rem',
    }}>
      <span style={{ lineHeight: 1.5 }}>{cfg.text}</span>
      <div style={{ display: 'flex', gap: '7px', alignItems: 'center' }}>
        {cfg.action && (
          <button
            onClick={cfg.action.onClick}
            style={{
              padding: '5px 13px', borderRadius: '8px', border: 'none',
              background: cfg.color, color: '#fff',
              fontSize: '0.82rem', fontWeight: 700, cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
          >
            {cfg.action.label}
          </button>
        )}
        {cfg.dismissible && (
          <button
            onClick={() => dismissNudge(cfg.dismissKey)}
            style={{
              padding: '4px 8px', borderRadius: '8px',
              border: '1px solid var(--border-color, #ccc)',
              background: 'transparent', color: 'var(--text-muted)',
              fontSize: '0.78rem', cursor: 'pointer',
            }}
            aria-label="Dismiss"
          >
            ✕
          </button>
        )}
      </div>
    </div>
  );
}
